import * as Moment from 'moment';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment)

export default moment;

